export default {
  confirmBtnText: "OK",
  cancelBtnText: "Cancel",
  selectedText: "selected",
  allText: "All",
  selectTipText: "Please select",
  inputPlaceholder: "Please enter",
  goSelectText: "to choose",
  overMessage: "Select up to ",
  leastMessage: "Select at least ",
  funtype: {
    defaultTitle: 'Selective function',
    customEmptyText: "No matching function, select the classification",
    emptyText: "No correlation yet. Try another keyword",
    cateDialogTitle: "Please select category",
    cateDialogSubtitleL: "Please select the category of",
    cateDialogSubtitleR: "for a better recommendation"
  },
  expectedCity: {
    defaultTitle: "Select intended city",
    locationCityText: "Current location city",
    hotCityTitleText: "Hot city",
    quanguoTitleText: "The whole country",
    gangaotaiTitleText: "Hong Kong, Macao and Taiwan",
    guowaiTitleText: "abroad",
    yixianCityTitleText: "First-tier/new first-tier",
    erxianCityTitleText: "Second-tier city",
  },
  graduatesDialog: {
    majordefaultTitle: "Select Major",
    certificationdefaultTitle: "Select Certifications",
    it_skilldefaultTitle: "Select Skills/Languages",
    industrydefaultTitle: "Select Industry",
    emptyText: "No results found",
  },
  livingArea: {
    'title': 'Select Living Area'
  }
};
